export default "__VITE_ASSET__M1XJp_fm__"